import { render } from "./SettingItem.vue?vue&type=template&id=5813d724&scoped=true"
import script from "./SettingItem.vue?vue&type=script&lang=js"
export * from "./SettingItem.vue?vue&type=script&lang=js"

import "./SettingItem.vue?vue&type=style&index=0&id=5813d724&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5813d724"]])

export default __exports__